import bulkcredits from "./bulkcredits.component";
import bulkcreditsUrls from "./bulkcredits.urls";
import BulkcreditsTransforms from "./bulkcredits.transforms";

const bulkcreditsModule = angular
  .module("app.components.bulkcredits", [])
  .component("bulkcreditsPage", bulkcredits)
  .service("BulkcreditsTransforms", BulkcreditsTransforms)
  .config(bulkcreditsUrls);

export default bulkcreditsModule;



// WEBPACK FOOTER //
// ./src/pages/bulkcredits/bulkcredits.module.js